<template>
  <div class="max-w-7xl mx-auto">
    <div class="mt-5">
      <div class="flex justify-between mb-8">
        <div class="flex-col">
          <h1 class="text-2xl font-medium">{{ courseInfo.title }}</h1>
          <p class="text-gray-900 mb-1">{{ courseInfo.description }}</p>
        </div>
        <div class="flex-col">
          <button
            @click="$router.push(`/admin/lessons/new/${courseInfo._id}`)"
            type="button"
            class="btn-primary"
          >
            Add New
          </button>
        </div>
      </div>
      <div
        v-for="lesson in lessons"
        :key="lesson._id"
        class="flex justify-between"
      >
        <div class="flex-col">
          <h1 class="text-2xl font-medium">{{ lesson.title }}</h1>
          <p class="text-gray-900 mb-1">
            {{ lesson.description }}
          </p>
          <p class="text-gray-800">ESTD: {{ lesson.estdTime }}</p>
        </div>
        <div class="flex-col">
          <router-link
            :to="`/admin/products/`"
            type="button"
            class="inline-flex items-center px-4 py-2 border-2 border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primaryColor hover:bg-secondaryColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 hover:no-underline"
          >
            Edit
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import lesson from '@/services/lesson';

export default {
  name: 'key',
  layout: 'admin',
  components: {},
  data() {
    return {
      courseId: null,
      courseInfo: {},
      lessons: [],
    };
  },
  created() {
    console.log(this.$route.params);
    this.courseId = this.$route.params.courseId;
    this.getLessons();
  },
  methods: {
    async getLessons() {
      store.commit('toggleLoading', true);
      await lesson
        .getLessons(this.courseId)
        .then(async (result) => {
          this.courseInfo = result.courseData;
          this.lessons = result.lessons;
          store.commit('toggleLoading', false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 401) {
            this.$router.push('/m/login');
          }
          store.commit('toggleLoading', false);
          console.error(err);
        });
    },
  },
};
</script>
<style scoped>
.box {
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.05);
  @apply p-5 rounded my-5 pl-5;
}
.box-title {
  @apply text-primaryColor text-xl flex pl-5 cursor-default;
  font-weight: 900;
}
.box-md {
  @apply p-5;
}
.box-btn {
  @apply mt-1 inline-flex items-center py-2 px-4 border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primaryColor;
}
.box-btn:focus {
  @apply outline-none;
}
.box-btn:hover {
  @apply bg-secondaryColor;
}
.btn-box:disabled {
  @apply opacity-50 cursor-not-allowed !important;
}
</style>
